// Public profile enhancements share the site's chrome without booting the SPA/game.
import './site.css';
import './gateway.css';
import './profiles.css';
import { bindShellNavigation } from './shell.ts';
const header = document.querySelector<HTMLElement>('.site-header');
if (header) bindShellNavigation(header);
